var map = {
	"./cnn-richard-prince.jpg": 397,
	"./cnn-richard-prince.mp4": 350,
	"./cnn-richard-prince.webm": 351,
	"./marc-amalia-cut.jpg": 398,
	"./marc-amalia-cut.mp4": 352,
	"./marc-amalia-cut.webm": 353
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 81;



/*****************
 ** WEBPACK FOOTER
 ** ./components/Message/videos ^\.\/.*$
 ** module id = 81
 ** module chunks = 0
 **/